<app-dialog-container
  title="{{ 'print' | translate }}"
  (confirmButtonHandler)="submit()"
  confirmButtonText="{{ 'print' | translate }}"
>
  <form>
    <app-ui-select
      [label]="'excludedCompetences' | translate"
      [control]="excludedCompetences"
      [options]="data.competenceOptions"
      [isMultiple]="true"
    ></app-ui-select>
    <app-ui-select
      [label]="'excludedJobPositions' | translate"
      [control]="excludedPositions"
      [options]="jobPositions$ | async"
      [isMultiple]="true"
    ></app-ui-select>
    <app-ui-select
      [label]="'excludedRequirements' | translate"
      [control]="excludedRequirements"
      [options]="requirementTypes"
      [isMultiple]="true"
    ></app-ui-select>
    <app-ui-select
      [label]="'excludedUsers' | translate"
      [control]="excludedUsers"
      [options]="data.userOptions"
      [isMultiple]="true"
    ></app-ui-select>
    <app-shared-ui-datepicker
      label="{{ 'startDate' | translate }}"
      [control]="date"
    ></app-shared-ui-datepicker>
    <app-ui-select
      label="{{ 'fileType' | translate }}"
      [control]="fileType"
      [options]="formOptions"
      [isMultiple]="false"
    ></app-ui-select>
  </form>
</app-dialog-container>
